const Loading = () => {
  return (
    <div className="h-screen w-full bg-black/40 absolute z-10 flex items-center justify-center text-white text-center left-0 top-0">
      <h3 className="text-xl">
        Cargando ...
        <br />
        🐌💌 ¡Paciencia, que estamos en modo caracol digital!
      </h3>
    </div>
  );
};

export default Loading;
